import { feedbackButtonTitle } from './TimeStreamFeedback.locstring.json';
import * as styles from './TimeStreamFeedback.scss';
import { useCanvasConfig } from '../hooks/useCanvasConfig';
import { getCanvasBounds } from '../viewstate';
import { ActionButton } from '@fluentui/react/lib/Button';
import type { IIconProps } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import SkipLinkRegionToFirstFocusableChild from 'owa-skip-link/lib/components/SkipLinkRegionToFirstFocusableChild';
import { lazyUpdateFeedbackArea } from 'owa-smiley-feedback';
import { openFlexPane } from 'owa-suite-header-apis';
import { lazyLaunchInAppFeedback } from 'owa-uservoice';
import * as React from 'react';

const feedbackIcon: IIconProps = {
    iconName: ControlIcons.CommentUrgent,
    styles: { root: styles.feedbackButtonIcon },
};

export default observer(function TimeStreamFeedback() {
    const config = useCanvasConfig();

    const launchInternalFeedbackForm = React.useCallback(() => {
        if (config.feedbackDisplayArea) {
            lazyUpdateFeedbackArea.importAndExecute(config.feedbackDisplayArea);
        }
        openFlexPane('OwaFeedback');
    }, [config.feedbackDisplayArea]);

    const openFeedbackPanel = React.useCallback(() => {
        isFeatureEnabled('fwk-feedbackCharm')
            ? launchInternalFeedbackForm()
            : lazyLaunchInAppFeedback.importAndExecute();
    }, [launchInternalFeedbackForm]);

    const title = loc(feedbackButtonTitle);

    // Avoid collision with left toolbox
    const { height } = getCanvasBounds();
    if (height <= 285) {
        return null;
    }

    return (
        <SkipLinkRegionToFirstFocusableChild
            role="complementary"
            regionNameResourceId={feedbackButtonTitle}
            className={styles.feedback}>
            <ActionButton
                className={styles.feedbackButton}
                iconProps={feedbackIcon}
                title={title}
                onClick={openFeedbackPanel}>
                {title}
            </ActionButton>
        </SkipLinkRegionToFirstFocusableChild>
    );
});
